import React from 'react';
import { Modal, Box, Typography, Divider, Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import GoogleIcon from '@mui/icons-material/Google'; 
import { signInWithGoogle } from '../sign-in/SignInGoogle';

interface WelcomeBackModalProps {
  open: boolean;
  onClose: () => void;
  onSignIn: () => void;  
  sx?: object;
}

const WelcomeBackModal: React.FC<WelcomeBackModalProps> = ({ open, onClose, onSignIn }) => {
  const { name, email, login, googleLogin } = useAuth();

  const obscureEmail = (email: string): string => {
    const [username, domain] = email.split('@');
    if(username != null){
      const obscuredUsername = username.slice(0, 3) + '****'; 
      const obscuredDomain = '****' + domain.slice(-4); 
      return `${obscuredUsername}@${obscuredDomain}`;
    }
    else return '';
  };

  const handleGoogleSignIn = async () => {
    onClose();
  
    try {
      const result = await signInWithGoogle(false);
      
      if (result) {
        const { response, idToken, /*accessToken*/ } = result;


        if (response.status === 200) {
          
          googleLogin(idToken, /*accessToken*/);

          if (response.token) {
            login(response.token);
            onClose(); 
          }
      } 
      else {
        console.error('No se recibió una respuesta válida del servidor.');
      }
    }
    } catch (error) {
      console.error('Error de autenticación con Google:', error);
    } 
  
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="welcome-back-modal-title"
      aria-describedby="welcome-back-modal-description"
    >
     <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '80%', sm: '70%', md: '50%', lg: '35%',xl:'25%' },
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        minHeight: { xs: '40%', sm: '40%',xl:'20%' },
        maxHeight: '90vh',
        overflow: 'auto',
      }}
    >
       <IconButton
          sx={{
            position: 'absolute',
            top:0,
            right: 8,
            color: 'text.primary',
            zIndex: 1,
          }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
    
        <Typography
          id="welcome-back-modal-title"
          variant="h6"
          component="h2"
          sx={{
            fontSize: { xs: '16px', sm: '18px' },
            fontWeight: 'bold',
            pt: {xs:6, sm:0},
          }}
        >
          Hola de nuevo, {name}
        </Typography>
      </Box>

      <Divider sx={{ width: "100%" }} />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', flexGrow: 1, justifyContent: 'center', gap: 2 }}>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <MailOutlineIcon sx={{ marginRight: '8px', color: 'text.secondary' }} />
          <Typography
            variant="body1"
            sx={{ fontWeight: '300', fontSize: { xs: '14px', sm: '16px' } }}
          >
            {obscureEmail(email!)}
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            mt: 4,
            width: '80%',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'none',
            fontWeight: 'bold',
            backgroundColor: 'green',
            color: 'white',
            '&:hover': {
              backgroundColor: 'darkGreen',
            },
          }}
          onClick={handleGoogleSignIn}
        >
          <GoogleIcon sx={{ marginRight: '8px' }} /> 
          Continuar con Google
        </Button>

        <Typography variant="body2" sx={{ display: 'inline-flex', alignItems: 'center' }}>
          ¿No eres tú? 
          <Button 
            variant="text" 
            sx={{ 
              textTransform: 'none', 
              color: 'green', 
              textDecoration: 'underline', 
              pl: 1 
            }} 
            onClick={onSignIn}
          >
            Usa otra cuenta
          </Button>
        </Typography>
      </Box>
    </Box>

    </Modal>
  );
};

export default WelcomeBackModal;
